import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	mailGroup: {
		id: 'spa-apps-sidebar-global-settings-system.menu.mail.mail-group',
		defaultMessage: 'Mail',
		description: 'Navigation group heading for mail group settings items',
	},
	globalMailSettings: {
		id: 'spa-apps-sidebar-global-settings-system.menu.mail.global-mail-settings',
		defaultMessage: 'Global Mail Settings',
		description: 'Navigation item which links to a global mail settings page',
	},
	outgoingMail: {
		id: 'spa-apps-sidebar-global-settings-system.menu.mail.outgoing-mail',
		defaultMessage: 'Outgoing Mail',
		description: 'Navigation item which links to a outgoing mail settings page',
	},
	incomingMail: {
		id: 'spa-apps-sidebar-global-settings-system.menu.mail.incoming-mail',
		defaultMessage: 'Incoming Mail',
		description: 'Navigation item which links to a incoming mail settings page',
	},
	sendEmail: {
		id: 'spa-apps-sidebar-global-settings-system.menu.mail.send-email',
		defaultMessage: 'Send email',
		description: 'Navigation item which links to a send email settings page',
	},
});
